export const DEBUG = process.env.NODE_ENV !== 'production';
export const LOMA_URL_CLIENT = process.env.NEXT_PUBLIC_LOMA_URL_CLIENT || '';
export const RETURNS_GRAPHQL_URL =
  process.env.NEXT_PUBLIC_RETURNS_GRAPHQL_URL || '';
export const RETURN_SERVICES_URL =
  process.env.NEXT_PUBLIC_RETURN_SERVICES_URL || '';
export const NOFLAKE_URL = process.env.NEXT_PUBLIC_NOFLAKE_URL || '';
